import React from 'react';

import styled from '@emotion/styled';
import Section from '../layout/section';
import ByLine from '../content/by-line';

const HeaderSection = styled.section`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
`;

const TierListHeader = ({ title, description, author, lastPublish }) => {
  return (
    <Section>
      <HeaderSection>
        <h1 style={{ width: '100%', textAlign: 'center' }}>{title}</h1>
        <ByLine date={lastPublish} author={author} canUpdate />
      </HeaderSection>
      {description && (
        <HeaderSection>
          <article>{description}</article>
        </HeaderSection>
      )}
    </Section>
  );
};

export default TierListHeader;
